import axios from '@/axios'

export let service = {
  getNominalZafit(payload) {
    return axios.get(`/zakat-fitrah`, payload)
  }
}

export const doaZafit = {
  latin: `Nawaitu an'ukhrija zakaatalfithri 'annii wa'anjamii'i maa yalza munii nafakootuhum syar'an fardhon lillaahi ta'aala `,
  terjemah: `"Aku niat mengeluarkan zakat fitrah untuk diriku dan seluruh orang yang nafkahnya menjadi tanggunganku fardu karena Allah ta'aala." `
}